import { render } from "./AsBannersCatalog.vue?vue&type=template&id=e1353ea4&ts=true"
import script from "./AsBannersCatalog.vue?vue&type=script&lang=ts"
export * from "./AsBannersCatalog.vue?vue&type=script&lang=ts"

import "./AsBannersCatalog.vue?vue&type=style&index=0&id=e1353ea4&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__